import { Component, OnInit } from '@angular/core';
import { User } from '../../../models/user';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-account-profile-card',
  imports: [],
  templateUrl: './account-profile-card.html',
  styleUrl: './account-profile-card.scss',
})
export class AccountProfileCard implements OnInit {
  constructor(private authService: AuthService) {}

  get profile(): User | null {
    return this.authService.profile();
  }

  ngOnInit(): void {
    this.authService.getProfile();
  }
}
